import React, { useState } from 'react';
import {
  Button,
  Flex,
  Logo,
  Spacer,
  Text,
  TextInput,
  Theme,
  ThemePicker,
} from 'vcc-ui';

export const Result = ({ variant, rtl, theme }) => {
  const [text, setText] = useState('');

  return (
    <Flex extend={{ flexGrow: 1 }}>
      <Text variant="bates" extend={{ textAlign: 'center' }}>
        Result
      </Text>
      <Spacer size={2} />
      <Flex extend={{ flexGrow: 1 }} dir={rtl ? 'rtl' : 'ltr'}>
        <ThemePicker direction={rtl ? 'rtl' : 'ltr'} variant={theme}>
          <Theme>
            {(theme) => (
              <Flex
                extend={{
                  flexGrow: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: theme.color.background.primary,
                }}
              >
                <Spacer size={4} />
                <Logo alt="logo" type="spreadmark" height={14} />
                <Spacer size={4} />
                <Flex
                  extend={{
                    padding: 16,
                    [theme.breakpoints.fromM]: {
                      flexDirection: 'row',
                      alignItems: 'center',
                    },
                  }}
                >
                  <TextInput
                    value={text}
                    size={4}
                    name="live-demo-name"
                    onChange={(e) => {
                      setText(e.target.value);
                    }}
                    label={rtl ? 'الاسم الاول' : 'First Name'}
                  />
                  <Spacer />
                  <Button intent="secondary" variant={variant}>
                    {rtl ? 'عرض' : 'Submit'}
                  </Button>
                </Flex>
                <Spacer size={4} />
              </Flex>
            )}
          </Theme>
        </ThemePicker>
      </Flex>
    </Flex>
  );
};
